export default __webpack_public_path__ + "static/media/pic4.8e1059a2.jpg";